<template>
  <div class="message-content">
    <div v-html="displayContentHtml" />
    <expand-content-control v-if="contentIsTruncated" class="expand-content-control"
                            :collapsed="!expanded" @expand="expand" @collapse="collapse" />
  </div>
</template>

<script>
import escape from 'lodash/escape'
import ExpandContentControl from '../components/expand-content-control'
import { nextTick } from 'vue'
import truncate from 'lodash/truncate'
import linkifyHtml from 'linkify-html'

const CONTENT_TRUNCATED_LENGTH = 200
export default {
  components: { ExpandContentControl },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    contentIsTruncated() {
      return this.content.length > CONTENT_TRUNCATED_LENGTH
    },
    displayContentHtml() {
      // First we use `escape` to ensure that any HTML markup in the original content will not be rendered
      // (e.g. replacing < with &lt;).
      // Then (if we're collapsing a long message) we truncate to the appropriate length.
      // Finally, we use linkifyHtml to turn bare URLs, domains, and email addresses into appropriate links.
      if (this.expanded) {
        return linkifyHtml(escape(this.content))
      } else {
        return linkifyHtml(truncate(escape(this.content), { length : CONTENT_TRUNCATED_LENGTH }))
      }
    }
  },
  methods: {
    expand() {
      this.expanded = true
      nextTick(() => {
        document.dispatchEvent(new Event('agra:embedly-div-added'))
      })
    },
    collapse() {
      this.expanded = false
    }
  }
}
</script>

<style scoped lang="scss">
  .message-content {
    font-size: 14px;
    line-height: 28px;
    white-space: pre-line;
    word-break: break-word;
  }
</style>
